var render = function render(_c,_vm){return _c('img',_vm._b({directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.props.src),expression:"props.src"}],key:_vm.props.key},'img',_vm.data.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }